:host {
  display: block;
  .status {
    width: 10px;
    height: 10px;
    border-radius: 5px;
    margin-right: 10px;
  }
  .status-online {
    background-color: var(--av-color-success);
  }
  .status-pending {
    background-color: vaR(--av-color-warning);
  }
}
